
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as ZmlyZWJhc2UvYXBw from 'firebase/app';
import * as ZmlyZWJhc2UvYXBwLWNoZWNr from 'firebase/app-check';
import * as ZmlyZWJhc2UvYXV0aA from 'firebase/auth';
import * as ZmlyZWJhc2UvZmlyZXN0b3Jl from 'firebase/firestore';
import * as ZmlyZWJhc2UvbWVzc2FnaW5n from 'firebase/messaging';
import * as ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw from 'firebase/remote-config';
import * as ZmlyZWJhc2Uvc3RvcmFnZQ from 'firebase/storage';
import * as d2FzbTpqcy1zdHJpbmc from './storeflow-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_ZmlyZWJhc2UvYXBwLWNoZWNr_ = ZmlyZWJhc2UvYXBwLWNoZWNr;
const _ref_ZmlyZWJhc2UvYXBw_ = ZmlyZWJhc2UvYXBw;
const _ref_ZmlyZWJhc2UvYXV0aA_ = ZmlyZWJhc2UvYXV0aA;
const _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_ = ZmlyZWJhc2UvZmlyZXN0b3Jl;
const _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_ = ZmlyZWJhc2UvbWVzc2FnaW5n;
const _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_ = ZmlyZWJhc2Uvc3RvcmFnZQ;
const _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_ = ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForUint8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'org.khronos.webgl.Uint8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.getMethodImplForFileList' : (obj, index) => obj[index],
    'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.readAsDataURL_$external_fun' : (_this, p0) => _this.readAsDataURL(p0),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'dev.gitlive.firebase.externals.jsObject' : () => ({}),
    'dev.gitlive.firebase.externals.jsSet' : (target, key, value) => { target[key] = value },
    'dev.gitlive.firebase.externals.jsGet' : (target, key) => target[key],
    'dev.gitlive.firebase.externals.jsonStringify' : (value) => JSON.stringify(value),
    'dev.gitlive.firebase.externals.jsObjectEntries' : (target) => Object.entries(target),
    'dev.gitlive.firebase.externals.jsObjectKeys' : (target) => Object.keys(target),
    'dev.gitlive.firebase.externals.jsIsArray' : (value) => Array.isArray(value),
    'dev.gitlive.firebase.externals.jsonParse' : (value) => JSON.parse(value),
    'dev.gitlive.firebase.externals.jsContainsValue' : (target, key) => target[key] != undefined,
    'dev.gitlive.firebase.externals.jsTypeOf' : (value) => typeof value,
    'dev.gitlive.firebase.externals.jsAnyAsString' : (value) => value,
    'dev.gitlive.firebase.externals.jsAnyAsDouble' : (value) => value,
    'dev.gitlive.firebase.externals.jsAnyAsBoolean' : (value) => value,
    'dev.gitlive.firebase.externals.jsErrorCode' : (error) => error.code,
    'dev.gitlive.firebase.externals.options_$external_prop_getter' : (_this) => _this.options,
    'dev.gitlive.firebase.externals.getApp_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvYXBw_.getApp(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.externals.apiKey_$external_prop_getter' : (_this) => _this.apiKey,
    'dev.gitlive.firebase.externals.appId_$external_prop_getter' : (_this) => _this.appId,
    'dev.gitlive.firebase.externals.authDomain_$external_prop_getter' : (_this) => _this.authDomain,
    'dev.gitlive.firebase.externals.databaseURL_$external_prop_getter' : (_this) => _this.databaseURL,
    'dev.gitlive.firebase.externals.messagingSenderId_$external_prop_getter' : (_this) => _this.messagingSenderId,
    'dev.gitlive.firebase.externals.gaTrackingId_$external_prop_getter' : (_this) => _this.gaTrackingId,
    'dev.gitlive.firebase.externals.projectId_$external_prop_getter' : (_this) => _this.projectId,
    'dev.gitlive.firebase.externals.storageBucket_$external_prop_getter' : (_this) => _this.storageBucket,
    'dev.gitlive.firebase.externals.initializeApp_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvYXBw_.initializeApp(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.Timestamp_$external_fun' : (p0, p1) => new _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.Timestamp(p0, p1),
    'dev.gitlive.firebase.firestore.externals.now_$external_fun' : (_this, ) => _this.now(),
    'dev.gitlive.firebase.firestore.externals.Companion_$external_object_getInstance' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.Timestamp,
    'dev.gitlive.firebase.firestore.externals.seconds_$external_prop_getter' : (_this) => _this.seconds,
    'dev.gitlive.firebase.firestore.externals.nanoseconds_$external_prop_getter' : (_this) => _this.nanoseconds,
    'dev.gitlive.firebase.firestore.externals.toMillis_$external_fun' : (_this, ) => _this.toMillis(),
    'dev.gitlive.firebase.firestore.externals.isEqual_$external_fun' : (_this, p0) => _this.isEqual(p0),
    'dev.gitlive.firebase.firestore.externals.Timestamp_$external_class_instanceof' : (x) => x instanceof _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.Timestamp,
    'dev.gitlive.firebase.firestore.externals.id_$external_prop_getter' : (_this) => _this.id,
    'dev.gitlive.firebase.firestore.externals.path_$external_prop_getter' : (_this) => _this.path,
    'dev.gitlive.firebase.firestore.externals.DocumentReference_$external_class_instanceof' : (x) => x instanceof _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.DocumentReference,
    'dev.gitlive.firebase.firestore.externals.isEqual_$external_fun_1' : (_this, p0) => _this.isEqual(p0),
    'dev.gitlive.firebase.firestore.externals.FieldValue_$external_class_instanceof' : (x) => x instanceof _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.FieldValue,
    'dev.gitlive.firebase.firestore.externals.FieldValue_$external_class_get' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.FieldValue,
    'dev.gitlive.firebase.firestore.externals.serverTimestamp_$external_fun' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.serverTimestamp(),
    'dev.gitlive.firebase.firestore.externals.GeoPoint_$external_class_instanceof' : (x) => x instanceof _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.GeoPoint,
    'dev.gitlive.firebase.firestore.externals.docs_$external_prop_getter' : (_this) => _this.docs,
    'dev.gitlive.firebase.firestore.externals.id_$external_prop_getter_1' : (_this) => _this.id,
    'dev.gitlive.firebase.firestore.externals.data_$external_fun' : (_this, p0, isDefault0) => _this.data(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.firestore.externals.exists_$external_fun' : (_this, ) => _this.exists(),
    'dev.gitlive.firebase.firestore.externals.get_$external_fun' : (_this, p0, p1, isDefault0) => _this.get(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.persistentLocalCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.persistentLocalCache(p0),
    'dev.gitlive.firebase.firestore.externals.memoryEagerGarbageCollector_$external_fun' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryEagerGarbageCollector(),
    'dev.gitlive.firebase.firestore.externals.memoryLruGarbageCollector_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryLruGarbageCollector(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.firestore.externals.memoryLocalCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryLocalCache(p0),
    'dev.gitlive.firebase.firestore.externals.commit_$external_fun' : (_this, ) => _this.commit(),
    'dev.gitlive.firebase.firestore.externals.set_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.set(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.update_$external_fun' : (_this, p0, p1) => _this.update(p0, p1),
    'dev.gitlive.firebase.firestore.externals.doc_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.doc(p0),
    'dev.gitlive.firebase.firestore.externals.doc_$external_fun_1' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.doc(p0, p1),
    'dev.gitlive.firebase.firestore.externals.collection_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collection(p0, p1),
    'dev.gitlive.firebase.firestore.externals.onSnapshot_$external_fun' : (p0, p1, p2, p3) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, p2, p3),
    'dev.gitlive.firebase.firestore.externals.setDoc_$external_fun' : (p0, p1, p2, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.setDoc(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.updateDoc_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.updateDoc(p0, p1),
    'dev.gitlive.firebase.firestore.externals.deleteDoc_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.deleteDoc(p0),
    'dev.gitlive.firebase.firestore.externals.refEqual_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.refEqual(p0, p1),
    'dev.gitlive.firebase.firestore.externals.getDoc_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDoc(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.getDocFromCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocFromCache(p0),
    'dev.gitlive.firebase.firestore.externals.getDocFromServer_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocFromServer(p0),
    'dev.gitlive.firebase.firestore.externals.initializeFirestore_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.initializeFirestore(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.connectFirestoreEmulator_$external_fun' : (p0, p1, p2, p3, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.connectFirestoreEmulator(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'dev.gitlive.firebase.firestore.externals.getFirestore_$external_fun' : (p0, p1, isDefault0, isDefault1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getFirestore(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.collection_$external_fun_1' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collection(p0, p1),
    'dev.gitlive.firebase.firestore.externals.writeBatch_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.writeBatch(p0),
    'dev.gitlive.firebase.firestore.externals.query_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.query(p0, ...p1),
    'dev.gitlive.firebase.firestore.externals.limit_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.limit(p0),
    'dev.gitlive.firebase.firestore.externals.data_$external_fun_1' : (_this, ) => _this.data(),
    'dev.gitlive.firebase.firestore.externals.getCountFromServer_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getCountFromServer(p0),
    'dev.gitlive.firebase.firestore.externals.and_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.and(...p0),
    'dev.gitlive.firebase.firestore.externals.or_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.or(...p0),
    'dev.gitlive.firebase.firestore.externals.where_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.where(p0, p1, p2),
    'dev.gitlive.firebase.firestore.externals.where_$external_fun_1' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.where(p0, p1, p2),
    'dev.gitlive.firebase.firestore.externals.orderBy_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.orderBy(p0, p1),
    'dev.gitlive.firebase.firestore.externals.onSnapshot_$external_fun_1' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, p2),
    'dev.gitlive.firebase.firestore.externals.onSnapshot_$external_fun_2' : (p0, p1, p2, p3) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, p2, p3),
    'dev.gitlive.firebase.firestore.externals.getDocs_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocs(p0),
    'dev.gitlive.firebase.firestore.externals.getDocsFromCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocsFromCache(p0),
    'dev.gitlive.firebase.firestore.externals.getDocsFromServer_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocsFromServer(p0),
    'dev.gitlive.firebase.storage.externals.maxOperationRetryTime_$external_prop_getter' : (_this) => _this.maxOperationRetryTime,
    'dev.gitlive.firebase.storage.externals.maxUploadRetryTime_$external_prop_getter' : (_this) => _this.maxUploadRetryTime,
    'dev.gitlive.firebase.storage.externals.ref_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_.ref(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.storage.externals.getStorage_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_.getStorage(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.storage.externals.deleteObject_$external_fun' : (p0) => _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_.deleteObject(p0),
    'dev.gitlive.firebase.storage.externals.getDownloadURL_$external_fun' : (p0) => _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_.getDownloadURL(p0),
    'dev.gitlive.firebase.storage.externals.uploadBytes_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_.uploadBytes(p0, p1, p2),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'com.casecode.storeflow.core.common.share.jsShareText' : (text, subject, copiedNotice) => {
            const copy = () => {
                if (!navigator.clipboard) return;
                navigator.clipboard.writeText(text).then(() => {
                    const toast = document.createElement('div');
                    toast.textContent = copiedNotice;
                    toast.setAttribute('role', 'status');
                    toast.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
                        'background:#323232;color:#fff;padding:10px 16px;border-radius:8px;' +
                        'font:14px system-ui,sans-serif;z-index:2147483647;box-shadow:0 2px 8px rgba(0,0,0,.3);';
                    document.body.appendChild(toast);
                    setTimeout(() => toast.remove(), 2500);
                }).catch(() => {});
            };
            const data = { title: subject, text: text };
            if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
                navigator.share(data).catch((e) => { if (!e || e.name !== 'AbortError') copy(); });
            } else {
                copy();
            }
        },
    'com.casecode.storeflow.core.common.voice.jsIsSpeechRecognitionSupported' : () => !!(window.SpeechRecognition || window.webkitSpeechRecognition),
    'com.casecode.storeflow.core.common.voice.jsRecognizeOnce' : (lang) => new Promise((resolve) => {
            const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            const r = new Recognition();
            r.lang = lang;
            r.interimResults = false;
            r.maxAlternatives = 1;
            let settled = false;
            const done = (v) => { if (!settled) { settled = true; resolve(v); } };
            r.onresult = (e) => done(e.results[0][0].transcript);
            r.onerror = (e) => done('__error__:' + e.error);
            r.onend = () => done(null);
            try { r.start(); } catch (err) { done('__error__:start-failed'); }
        }),
    'com.casecode.storeflow.core.notifications.BrowserNotification_$external_fun' : (p0, p1, isDefault0) => new Notification(p0, isDefault0 ? undefined : p1, ),
    'com.casecode.storeflow.core.notifications.permission_$external_prop_getter' : (_this) => _this.permission,
    'com.casecode.storeflow.core.notifications.requestPermission_$external_fun' : (_this, ) => _this.requestPermission(),
    'com.casecode.storeflow.core.notifications.Companion_$external_object_getInstance' : () => Notification,
    'com.casecode.storeflow.core.notifications.jsNotificationOptions' : (body) => ({ body: body }),
    'dev.gitlive.firebase.auth.externals.currentUser_$external_prop_getter' : (_this) => _this.currentUser,
    'dev.gitlive.firebase.auth.externals.onAuthStateChanged_$external_fun' : (_this, p0) => _this.onAuthStateChanged(p0),
    'dev.gitlive.firebase.auth.externals.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
    'dev.gitlive.firebase.auth.externals.GoogleAuthProvider_$external_fun' : () => new _ref_ZmlyZWJhc2UvYXV0aA_.GoogleAuthProvider(),
    'dev.gitlive.firebase.auth.externals.credential_$external_fun' : (_this, p0, p1) => _this.credential(p0, p1),
    'dev.gitlive.firebase.auth.externals.credentialFromResult_$external_fun' : (_this, p0) => _this.credentialFromResult(p0),
    'dev.gitlive.firebase.auth.externals.Companion_$external_object_getInstance' : () => _ref_ZmlyZWJhc2UvYXV0aA_.GoogleAuthProvider,
    'dev.gitlive.firebase.auth.externals.user_$external_prop_getter' : (_this) => _this.user,
    'dev.gitlive.firebase.auth.externals.signInWithPopup_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.signInWithPopup(p0, p1),
    'dev.gitlive.firebase.auth.externals.providerData_$external_prop_getter' : (_this) => _this.providerData,
    'dev.gitlive.firebase.auth.externals.delete_$external_fun' : (_this, ) => _this.delete(),
    'dev.gitlive.firebase.auth.externals.getIdToken_$external_fun' : (_this, p0) => _this.getIdToken(p0),
    'dev.gitlive.firebase.auth.externals.idToken_$external_prop_getter' : (_this) => _this.idToken,
    'dev.gitlive.firebase.auth.externals.OAuthProvider_$external_fun' : (p0) => new _ref_ZmlyZWJhc2UvYXV0aA_.OAuthProvider(p0),
    'dev.gitlive.firebase.auth.externals.signOut_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.signOut(p0),
    'dev.gitlive.firebase.auth.externals.user_$external_prop_getter_1' : (_this) => _this.user,
    'dev.gitlive.firebase.auth.externals.signInWithCustomToken_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.signInWithCustomToken(p0, p1),
    'dev.gitlive.firebase.auth.externals.getAuth_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvYXV0aA_.getAuth(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.auth.externals.displayName_$external_prop_getter' : (_this) => _this.displayName,
    'dev.gitlive.firebase.auth.externals.email_$external_prop_getter' : (_this) => _this.email,
    'dev.gitlive.firebase.auth.externals.photoURL_$external_prop_getter' : (_this) => _this.photoURL,
    'dev.gitlive.firebase.auth.externals.providerId_$external_prop_getter' : (_this) => _this.providerId,
    'dev.gitlive.firebase.auth.externals.uid_$external_prop_getter' : (_this) => _this.uid,
    'dev.gitlive.firebase.auth.externals.reauthenticateWithCredential_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.reauthenticateWithCredential(p0, p1),
    'dev.gitlive.firebase.remoteconfig.externals.asBoolean_$external_fun' : (_this, ) => _this.asBoolean(),
    'dev.gitlive.firebase.remoteconfig.externals.asString_$external_fun' : (_this, ) => _this.asString(),
    'dev.gitlive.firebase.remoteconfig.externals.getValue_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_.getValue(p0, p1),
    'dev.gitlive.firebase.remoteconfig.externals.getRemoteConfig_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_.getRemoteConfig(isDefault0 ? undefined : p0, ),
    'com.casecode.storeflow.core.data.auth.jsAddAppleScopes' : (provider) => { provider.addScope('email'); provider.addScope('name'); },
    'com.casecode.storeflow.core.data.auth.jsForceAccountChooser' : (provider) => { provider.setCustomParameters({ prompt: 'select_account' }); },
    'com.casecode.storeflow.core.data.notifications.getMessaging_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.getMessaging(p0),
    'com.casecode.storeflow.core.data.notifications.isSupported_$external_fun' : () => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.isSupported(),
    'com.casecode.storeflow.core.data.notifications.getToken_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.getToken(p0, isDefault0 ? undefined : p1, ),
    'com.casecode.storeflow.core.data.notifications.onMessage_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.onMessage(p0, p1),
    'com.casecode.storeflow.core.data.notifications.notification_$external_prop_getter' : (_this) => _this.notification,
    'com.casecode.storeflow.core.data.notifications.title_$external_prop_getter' : (_this) => _this.title,
    'com.casecode.storeflow.core.data.notifications.body_$external_prop_getter' : (_this) => _this.body,
    'com.casecode.storeflow.core.data.platform.setCustomLocale' : (languageCode) => window.__customLocale = languageCode,
    'com.casecode.storeflow.core.data.platform.browserLanguage' : () => navigator.language,
    'com.casecode.storeflow.core.data.repository.jsPrintHtml' : (html) => {
            const iframe = document.createElement('iframe');
            iframe.setAttribute('aria-hidden', 'true');
            iframe.setAttribute('tabindex', '-1');
            Object.assign(iframe.style, { position: 'fixed', left: '-10000px', top: '0', width: '400px', height: '600px', border: '0' });
            document.body.appendChild(iframe);
            const win = iframe.contentWindow;
            const doc = win.document;
            doc.open(); doc.write(html); doc.close();
            let removed = false;
            const remove = () => { if (!removed) { removed = true; iframe.remove(); } };
            const loaded = (img) => img.complete ? Promise.resolve() : new Promise((done) => { img.onload = done; img.onerror = done; });
            const fontsReady = (doc.fonts && doc.fonts.ready) ? doc.fonts.ready.catch(() => {}) : Promise.resolve();
            Promise.all([...Array.from(doc.images).map(loaded), fontsReady]).then(() => {
                win.addEventListener('afterprint', () => setTimeout(remove, 500));
                setTimeout(remove, 120000);
                win.focus();
                win.print();
            });
        },
    'com.casecode.storeflow.core.data.repository.jsBarcodeSvg' : (data, format) => { if (typeof JsBarcode === 'undefined') return ''; const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); JsBarcode(svg, data, { format: format, displayValue: false, height: 50, width: 2, margin: 0, marginLeft: 20, marginRight: 20 }); svg.setAttribute('preserveAspectRatio', 'none'); svg.removeAttribute('width'); svg.removeAttribute('height'); return svg.outerHTML; },
    'com.casecode.storeflow.core.data.repository.jsDownloadTextFile' : (content, fileName, mimeType) => { const blob = new Blob([content], { type: mimeType }); const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = fileName; document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url); },
    'com.casecode.storeflow.core.data.repository.jsGenerateInvoicePdf' : (dataJson) => window.generateInvoicePdf(dataJson),
    'com.casecode.storeflow.core.data.repository.jsGeneratePurchaseOrderPdf' : (dataJson) => window.generatePurchaseOrderPdf(dataJson),
    'com.casecode.storeflow.core.data.security.initializeAppCheck_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXBwLWNoZWNr_.initializeAppCheck(p0, p1),
    'com.casecode.storeflow.core.data.security.ReCaptchaV3Provider_$external_fun' : (p0) => new _ref_ZmlyZWJhc2UvYXBwLWNoZWNr_.ReCaptchaV3Provider(p0),
    'com.casecode.storeflow.core.data.security.token_$external_prop_getter' : (_this) => _this.token,
    'com.casecode.storeflow.core.data.security.getToken_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvYXBwLWNoZWNr_.getToken(p0, isDefault0 ? undefined : p1, ),
    'com.casecode.storeflow.core.data.staff.fillWithRandomValues' : (array) => crypto.getRandomValues(array),
    'com.casecode.storeflow.core.data.util.jsListenConnectivity' : (cb) => {
            const on = () => cb(true);
            const off = () => cb(false);
            window.addEventListener('online', on);
            window.addEventListener('offline', off);
            return { on, off };
        },
    'com.casecode.storeflow.core.data.util.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'com.casecode.storeflow.core.data.util.jsIsOnline' : () => navigator.onLine,
    'com.casecode.storeflow.core.data.util.jsUnlistenConnectivity' : (h) => {
            window.removeEventListener('online', h.on);
            window.removeEventListener('offline', h.off);
        },
    'com.casecode.storeflow.core.ui.jsPickTextFile' : () => new Promise((resolve) => { const input = document.createElement('input'); input.type = 'file'; input.accept = '.csv'; input.onchange = () => { const file = input.files && input.files[0]; if (!file) { resolve(null); return; } const reader = new FileReader(); reader.onload = () => resolve({ name: file.name, content: reader.result }); reader.onerror = () => resolve(null); reader.readAsText(file); }; input.click(); }),
    'com.casecode.storeflow.core.ui.name_$external_prop_getter' : (_this) => _this.name,
    'com.casecode.storeflow.core.ui.content_$external_prop_getter' : (_this) => _this.content,
    'com.casecode.storeflow.core.ui.jsFormatDate' : (millis) => new Date(millis).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }),
    'com.casecode.storeflow.core.ui.location.jsResolveLocation' : (lang) => new Promise((resolve) => {
            if (!navigator.geolocation) { resolve('error\tGeolocation is not supported by this browser'); return; }
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const lat = pos.coords.latitude;
                    const lng = pos.coords.longitude;
                    const url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1'
                        + '&lat=' + encodeURIComponent(lat) + '&lon=' + encodeURIComponent(lng)
                        + '&accept-language=' + encodeURIComponent(lang);
                    fetch(url, { headers: { 'Accept': 'application/json' } })
                        .then((r) => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
                        .then((json) => {
                            const a = (json && json.address) || {};
                            const street = [a.house_number, a.road].filter(Boolean).join(' ');
                            const name = street || a.neighbourhood || a.suburb || json.name || '';
                            const locality = a.city || a.town || a.village || a.suburb || a.county || '';
                            const parts = [name, locality, a.state, a.country]
                                .filter((p, i, all) => p && all.indexOf(p) === i);
                            const address = (parts.length ? parts.join(', ') : (json.display_name || ''))
                                .replace(/[\t\n]/g, ' ');
                            if (address) {
                                // Nominatim's usage policy and the ODbL require visible attribution.
                                const note = document.createElement('div');
                                note.textContent = 'Address data © OpenStreetMap contributors';
                                note.setAttribute('role', 'status');
                                note.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
                                    'background:#323232;color:#fff;padding:8px 14px;border-radius:8px;' +
                                    'font:12px system-ui,sans-serif;z-index:2147483647;';
                                document.body.appendChild(note);
                                setTimeout(() => note.remove(), 4000);
                            }
                            resolve(address ? 'ok\t' + lat + '\t' + lng + '\t' + address : 'error\tNo address found for location');
                        })
                        .catch((e) => resolve('error\tReverse geocoding failed: ' + (e && e.message)));
                },
                (err) => resolve(err && err.code === 1 ? 'denied' : 'error\t' + ((err && err.message) || 'Location unavailable')),
                { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 },
            );
        }),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.id_$external_prop_getter_1' : (_this) => _this.id,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'io.github.ismoy.imagepickerkmp.core.language.getBrowserLanguage' : () => window.navigator.language,
    'io.github.ismoy.imagepickerkmp.ui.currentTimeMillis' : () => Date.now(),
    'io.github.ismoy.imagepickerkmp.ui.currentTimeMillis_1' : () => Date.now(),
    'com.casecode.storeflow.core.datastore.readStorage' : (key) => { try { return window.localStorage.getItem(key); } catch (e) { return null; } },
    'com.casecode.storeflow.core.datastore.listenForStorageChanges' : (key, cb) => window.addEventListener('storage', (e) => { if (e.key === key) cb(e.newValue); }),
    'com.casecode.storeflow.core.datastore.__convertKotlinClosureToJsClosure_((String?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String?)->Unit)'](f, p0)),
    'com.casecode.storeflow.core.datastore.writeStorage' : (key, value) => { try { window.localStorage.setItem(key, value); return true; } catch (e) { return false; } },
    'com.casecode.storeflow.web.setCustomLocale' : (languageCode) => window.__customLocale = languageCode
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    